// assets/custom-section.js

// Google Sheets APIキーとシートIDを設定

// 橋のAPI key
const apiKey = 'AIzaSyBDG6lpv0qHhXE1iBH1S6qi0i1o8i7G1Vw';

// soomのAPI Key
// const apiKey = 'AIzaSyDCi9chd6ugajU2gbE54PpCXgtGiMBUn0Y';

// 橋のシートID
const sheetId = '194g1wbQ75IdO2Elr3o3JJ-pvTo0jVjC_sIJIi9cCvqE';

// soomのシートID
// const sheetId = '1x6lOM5jj3uoQ7AIf0uAZYB83hcMPE-Log0Re_WD2dXk';

// H列まで取得
const range = 'stockist-list!A2:H';

// Google Sheets APIのURLを作成
const url = `https://sheets.googleapis.com/v4/spreadsheets/${sheetId}/values/${range}?key=${apiKey}`;

const storeList = [];
const prefectureCityMap = {};

const stockistListElement = document.getElementById('stockist-list');
const prefectureSelect = document.getElementById('prefecture-select');
const citySelect = document.getElementById('city-select');
const typeSelect = document.getElementById('type-select');

fetch(url)
    .then(response => response.json())
    .then(data => {
        const rows = data.values || [];

        rows.forEach(row => {
            const li = document.createElement('li');

            const store = {
                prefecture: row[1] || '',
                city: row[6] || '',
                type: row[7] || '',
                name: row[0] || '',
                address: `${row[2] || ''}${row[3] || ''}${row[4] || ''}${row[5] || ''}`,
            };

            li.className = 'result-content';
            li.style.display = 'none';

            li.setAttribute('data-prefecture', store.prefecture);
            li.setAttribute('data-city', store.city);
            li.setAttribute('data-type', store.type);

            li.innerHTML = `
            <div class="left">
                <p>${store.name}</p>
            </div>
            <div class="right">
                <p>${row[2] ? row[2] : ''}${row[3] ? row[3] : ''}<br>${row[4] ? row[4] : ''}</p>
            </div>
            `;

            stockistListElement.appendChild(li);
            storeList.push(store);

            if (!prefectureCityMap[store.prefecture]) {
                prefectureCityMap[store.prefecture] = [];
            }

            if (store.city && !prefectureCityMap[store.prefecture].includes(store.city)) {
                prefectureCityMap[store.prefecture].push(store.city);
            }
        });

        console.log(prefectureCityMap);
    })
    .catch(error => console.error('Error:', error));

prefectureSelect.addEventListener('change', function() {
    const selectedPrefecture = this.value;
    const cities = prefectureCityMap[selectedPrefecture] || [];

    // 市区町村セレクトボックスを更新
    if (cities.length === 0) {
        citySelect.innerHTML = '<option value="">この地域には店舗がありません</option>';
    } else {
        citySelect.innerHTML = '<option value="">市区町村で絞り込み</option>';

        cities.forEach(city => {
            const option = document.createElement('option');
            option.value = city;
            option.textContent = city;
            citySelect.appendChild(option);
        });
    }

    citySelect.disabled = cities.length === 0;
    citySelect.value = '';

    filterStores();
});

citySelect.addEventListener('change', filterStores);

if (typeSelect) {
    typeSelect.addEventListener('change', filterStores);
}

function filterStores() {
    const selectedPrefecture = prefectureSelect.value;
    const selectedCity = citySelect.value;
    const selectedType = typeSelect ? typeSelect.value : '';

    console.log('Filtering stores with:', {
        selectedPrefecture,
        selectedCity,
        selectedType,
    });

    const stockistItems = document.querySelectorAll('#stockist-list li');
    let filteredCount = 0;

    stockistItems.forEach(store => {
        const matchesPrefecture = !selectedPrefecture || store.getAttribute('data-prefecture') === selectedPrefecture;
        const matchesCity = !selectedCity || store.getAttribute('data-city') === selectedCity;
        const matchesType = !selectedType || store.getAttribute('data-type') === selectedType;

        if (matchesPrefecture && matchesCity && matchesType) {
            store.style.display = '';
            filteredCount++;
        } else {
            store.style.display = 'none';
        }
    });

    let resultCountElement = document.getElementById('result-count');

    if (!resultCountElement) {
        resultCountElement = document.createElement('div');
        resultCountElement.id = 'result-count';
        resultCountElement.textContent = `検索結果：${filteredCount}件`;
        stockistListElement.insertBefore(resultCountElement, stockistListElement.firstChild);
    } else {
        resultCountElement.textContent = `検索結果：${filteredCount}件`;
    }
}